import type LocationModel from 'bcl/models/location';

function getStartSunday(): Date {
  const now = new Date();
  const day = now.getDay();
  const diff = day === 0 ? 7 : day;
  now.setDate(now.getDate() - diff);
  now.setHours(5, 0, 0, 0);
  // Remove 26 weeks (182 days)
  now.setDate(now.getDate() - 182);
  return now;
}
// create for the last 6 month
export async function createExampleStocktakings(store: any) {
  const existing = store.peekAll('stocktaking');
  console.log('existing stocktakings:', existing);
  if (existing.length > 0) {
    return false;
  }
  const startSunday = getStartSunday();
  const locations = store.peekAll('location');
  while (startSunday <= new Date()) {
    const models = locations.map((loc: LocationModel) => {
      return fetch(`/api/admin/createStocktaking/${loc.id}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          notes: 'created Example',
          company_id: 1,
          created_at: startSunday.toISOString().slice(0, 23),
          created_by: 1,
          updated_by: 1,
        }),
      });
    });

    await Promise.all(models);
    startSunday.setDate(startSunday.getDate() + 7);
  }

  return true;
}
